export default "__VITE_ASSET__Bg2kl9yu__"